// removed by extract-text-webpack-plugin
module.exports = {"filterName":"_1SpDhBpByOyUJLzdrzO2qQ","projectTags":"_1mI-IFpnTEdWantmetgmKi","projectContainer":"mS0EMMLj1XjHcwNeFF2wM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/projects/Projects.css
// module id = 369
// module chunks = 0